<template>
  <div class="toast"
       :class="[{'toastSuccess': toast.success}, {'toast--left-bottom': leftBottom}, {'animated fadeInDown': !leftBottom}, {'animateFast fadeInUp': leftBottom}]"
       :style="styleObj">
    <div class="toast-content">
      <div v-if="toast.success"
           class="toast__icon toast_icon__success icon-checkmark-circle">
      </div>
      <div v-if="!toast.success" class="toast__icon toast_icon__bell icon-bell"></div>
      <h4>{{ toast.text }}</h4>
    </div>
    <div class="cross pointer"
         @click="$emit('removeNow', toast.id)">
      <span class="icon-cross2"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['index', 'toast', 'arrayLength'],
  computed: {
    styleObj () {
      return {top: 60 * -this.index + this.arrayLength * 60 + 'px'}
    },
    leftBottom () {
      return this.toast.position && this.toast.position === 'bottomLeft'
    }
  },
  methods: {
    remove () {
      this.$emit('remove', this.toast.id)
    }
  },
  mounted () {
    this.remove()
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.toast.toastSuccess {
  color: #fff;
  background: #3ecf8e;
  text-shadow: 0 1px 3px rgba(36, 180, 126, .4);
}

.toast-content {
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.toast__icon {
  font-size: 24px;
  margin-right: 10px;
}

.toast {
  position: fixed;
  z-index: 1231313123123123;
  display: flex;
  top: 0;
  justify-content: space-between;
  right: 20px;
  min-height: 30px;
  max-width: 350px;
  padding: 10px 14px;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  background: #fff;
  border-radius: 4px;
  font-size: 15px;
  color: var(--blue);
  transition: all .4s ease;
}

.toast.toast--left-bottom {
  top: auto !important;
  bottom: 20px !important;
  left: 20px !important;
  right: auto !important;
}

.toast h4 {
  line-height: 1.4;
}

@media handheld, only screen and (max-width: 767px) {
  .toast {
    bottom: 1rem;
    top: auto !important;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(100% - 2rem);
    max-width: 500px;
    font-size: 14px;
    background: #222;
    color: #fff;
  }

  .toast h4 {
    font-weight: normal;
  }

  .toast .toast__icon {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// Toast.vue?336eae3e